export default "__VITE_ASSET__BGlSQzlD__"